// removed by extract-text-webpack-plugin
module.exports = {"root":"_2_3rp","fadeOutIn":"_129Zx"};